import { TextHelper } from './TextHelper';

export class DateHelper {

    public static dateToInternationalString(date: Date) {
        const dd = date.getDate();
        const mm = date.getMonth() + 1; // January is 0!
        const yyyy = date.getFullYear();
        return `${yyyy}-${DateHelper.zeroPad(mm)}-${DateHelper.zeroPad(dd)}`;
    }

    public static nowAsCompressedDateTimeString() {
        const date = new Date();

        const dd = date.getDate();
        const mm = date.getMonth() + 1; // January is 0!
        const yy = date.getFullYear().toString().substring(2, 3);
        const hrs = date.getHours();
        const mins = date.getMinutes();
        const secs = date.getSeconds();

        return `${yy}${DateHelper.zeroPad(mm)}${DateHelper.zeroPad(dd)}${DateHelper.zeroPad(hrs)}${DateHelper.zeroPad(mins)}${DateHelper.zeroPad(secs)}`;
    }

    private static zeroPad(val: number): string {
        return TextHelper.zeroPadNumber(val);
    }

    public static toDateOnlyStringFrom(year: number, month: number, day: number): string | undefined {
        return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T00:00:00.000Z`;
    }

    public static toDateOnlyString(dateInput: Date | string): string | undefined {
        const date = DateHelper.getDateObjectFrom(dateInput);
        if (date) {
            return `${DateHelper.dateToInternationalString(date)}T00:00:00.000Z`;
        }
        return undefined;
    }

    public static getDateObjectFrom(val: any): any {
        if (typeof val.getMonth === 'function') {
            return val;
        }

        return new Date(val);
    }

    public static isDate(val: any): boolean {
        if (val && typeof val.getMonth === 'function') {
            return true;
        }
        return false;
    }

    public static dateFromUtcDateString(utcDateString: string): Date | undefined {

        if (utcDateString && utcDateString.indexOf('0001-01-01T') === -1) {
            return this.adjustUtcDateToLocalDateOfSameDay(utcDateString);
        }
        return undefined;
    }

    public static getFirstDayOfMonth(date?: Date) {
        date ??= new Date();
        const y = date.getFullYear(), m = date.getMonth();
        return new Date(y, m, 1);
    }

    public static getLastDayOfMonth(date?: Date) {
        date ??= new Date();
        const y = date.getFullYear(), m = date.getMonth();
        return new Date(y, m + 1, 0);
    }


    public static toUkDateString(date: Date) {
        return `${TextHelper.zeroPadNumber(date.getDate())}/${TextHelper.zeroPadNumber(date.getMonth() + 1)}/${date.getFullYear()}`;
    }

    private static adjustUtcDateToLocalDateOfSameDay(utcString: string): Date | undefined {
        if (!utcString || utcString.length === 0) {
            return undefined;
        }
        const dateObj = DateHelper.getDateObjectFrom(utcString);
        const offset = dateObj.getTimezoneOffset();
        return (new Date(dateObj.getTime() + (60 * 1000 * offset)));
    }


}
